export default __webpack_public_path__ + "static/media/close.968072b4.svg";